<template>
    <div class="SignInWrapper">
        <div class="auth_header">
            <ul>
                <li @click="changeType(0)" :class="loginMethods ? 'active' : ''">手机号快捷登录<i></i></li>
                <li @click="changeType(1)" :class="loginMethods ? '' : 'active'">账号密码登录</li>
            </ul>
            <a href="javascript:void(0)" class="auth_close" @click="$auth.close"><i class="el-icon-close"></i></a>
        </div>
        <div class="auth_content">
            <div v-show="loginMethods" class="mobileSignIn">
                <el-form ref="mobileForm" :model="mobileData" :rules="mobileRules">
                    <el-form-item prop="mobile">
                        <el-input v-model="mobileData.mobile" type="text" placeholder="请输入手机号" clearable tabindex="1"
                                  maxlength="11"
                                  :show-word-limit="true"/>
                    </el-form-item>
                    <el-form-item prop="imgCode" class="imgCode">
                        <el-input v-model="mobileData.imgCode" type="text" placeholder="请输入图片验证码" maxlength="4"
                                  tabindex="2"
                                  clearable>
                            <template slot="append"><img :src="imgCodeSrc" @click="getImgCode"/></template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="smsCode">
                        <el-input v-model="mobileData.smsCode" type="text" placeholder="请输入短信验证码" maxlength="6"
                                  tabindex="3"
                                  clearable>
                            <template slot="append">
                                <a v-if="!showTimer" href="javascript:void(0)" @click="clickSmsCode">获取验证码</a>
                                <span v-else>{{ smsTimer }}</span>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-show="!loginMethods" class="accountSignIn">
                <el-form ref="accountForm" :model="accountData" :rules="accountRules">
                    <el-form-item prop="account">
                        <el-input v-model="accountData.account" type="text" placeholder="请输入手机号/账号" clearable
                                  tabindex="1"
                                  maxlength="25"
                                  :show-word-limit="true"/>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="accountData.password" type="password" placeholder="请输入密码" clearable
                                  tabindex="2"
                                  maxlength="15" :show-password="true"/>
                    </el-form-item>
                    <el-form-item prop="imgCode" class="imgCode" v-if="needImgCode">
                        <el-input v-model="accountData.imgCode" type="text" placeholder="请输入图片验证码" maxlength="4"
                                  tabindex="3"
                                  clearable>
                            <template slot="append"><img :src="imgCodeSrc" @click="getImgCode"/></template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="xyradio">
                <el-checkbox v-model="isAutoLogin">7天内自动登录</el-checkbox>
              <!--  <a href="javascript:void(0)" class="switchBtn" @click="$Register">注册</a> -->
            </div>
            <a v-if="loginMethods" href="javascript:void(0)" class="submitSignIn" @click="subSignInByMobile">登 录</a>
            <a v-if="!loginMethods && needImgCode" href="javascript:void(0)" class="submitSignIn"
               @click="subSignInByAccountImg">登 录</a>
            <a v-if="!loginMethods && !needImgCode" href="javascript:void(0)" class="submitSignIn"
               @click="subSignInByAccount">登 录</a>
            <!-- <div class="thirdPart">
                <p class="tit">其他登录方式：</p>
                <a :href="otherLogin.wechat" class="t_wechat" target="_blank" title="微信"></a>
                <a :href="otherLogin.qq" class="t_qq" target="_blank" title="QQ"></a>
                <a :href="otherLogin.weibo" class="t_weibo" target="_blank" title="微博"></a>
            </div> -->
        </div>
    </div>
</template>
<script>
  import { $Cookies } from '@/utils';
  import { getSMSCode, loginByMobile, loginByAccount, checkNeedImgCode } from '@/api/auth';
  import md5 from 'js-md5';
  import $store from '@/store';

  export default {
    data () {
      const checkMobile = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入手机号码'));
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return {
        loginMethods: true,
        imgCodeSrc: '',
        smsTimer: 60,
        smsDuration: 5 * 60,
        showTimer: false,
        isAutoLogin: true,
        needImgCode: false,
        mobileData: {
          mobile: '',
          imgCode: '',
          smsCode: ''
        },
        mobileRules: {
          mobile: [
            { validator: checkMobile, trigger: 'blur' }
          ],
          imgCode: [
            { required: true, message: '请输入图片验证码', trigger: 'blur' }
          ],
          smsCode: [
            { required: true, message: '请输入短信验证码', trigger: 'blur' }
          ]
        },
        accountData: {
          account: '',
          password: '',
          imgCode: ''
        },
        accountRules: {
          account: [
            { required: true, message: '请输入手机号/账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          imgCode: [
            { required: true, message: '请输入图片验证码', trigger: 'blur' }
          ]
        },
        otherLogin: {
          wechat: 'https://open.weixin.qq.com/connect/qrconnect?appid=wx289012f3bf87bdbe&response_type=code&state=ssjx&scope=snsapi_login&redirect_uri=http://www.g12e.org/thirdLogin/index.html%3FthirdPartyType%3D2#wechat_redirect',
          qq: 'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&response_type=code&client_id=101872626&scope=get_user_info&state=test&redirect_uri=http://www.g12e.org/thirdLogin/index.html%3FthirdPartyType%3D4',
          weibo:'https://api.weibo.com/oauth2/authorize?response_type=code&client_id=1194694642&state=test&redirect_uri=http://www.g12e.org/thirdLogin/index.html%3FthirdPartyType%3D1'
        }
      };
    },
    created() {
      window.addEventListener('keydown', this.handleKeyDown, true);
    },
    mounted () {
      $Cookies.remove('smsTimestamp');
      $Cookies.remove('uid');
      this.getImgCode();
    },
    methods: {
      //获取图片验证码
      getImgCode () {
        const url = '/api/g12eLogin/login/getPhotoRandCode';
        let xhr = new XMLHttpRequest();
        let token = $Cookies.get('authToken');
        if (token) {
          xhr.open('GET', url, true);
          xhr.responseType = 'blob';
          xhr.setRequestHeader('Authorization', token);
          xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
              this.imgCodeSrc = URL.createObjectURL(xhr.response);
            }
          };
          xhr.send(null);
        }
      },
      //切换登录方式
      changeType (type) {
        if (type === 0) {
          this.loginMethods = true;
          this.$refs.accountForm.resetFields();
        } else if (type === 1) {
          this.loginMethods = false;
          this.$refs.mobileForm.resetFields();
        }
      },
      //点击获取短信验证码，校验是否符合要求
      clickSmsCode () {
        const me = this;
        let flag = [];
        this.$refs.mobileForm.validateField(['mobile', 'imgCode'], error => {
          if (!error) {
            flag.push(error);
          }
          if (flag.length === 2) {
            if (flag[ 0 ] === '' && flag[ 1 ] === '') {
              me.getSmsCode();
            }
          }
        });
      },
      //获取短信验证码
      getSmsCode () {
        const me = this;
        const data = {
          mobilePhone: me.mobileData.mobile,
          randCode: me.mobileData.imgCode,
          platform: 10
        };
        getSMSCode(data).then(data => {
          if (data.success) {
            $Cookies.remove('smsTimestamp');
            me.$message({
              type: 'success',
              message: data.result.result
            });
            this.timer();
            let cookie = {
              timestamp: new Date().getTime(),
              mobile: me.mobileData.mobile
            };
            cookie = this.$Base64.encode(JSON.stringify(cookie));
            $Cookies.set('smsTimestamp', cookie);
          } else {
            me.$message({
              type: 'error',
              message: data.errorMsg,
              duration: 1500,
              onClose: () => {
                me.getImgCode();
              }
            });
          }
        });
      },
      //短信验证码倒计时
      timer () {
        const me = this;
        let _timeInterval = setInterval(function () {
          if (me.smsTimer === 0) {
            me.showTimer = false;
            me.smsTimer = 60;
            clearInterval(_timeInterval);
          } else if (me.smsTimer <= 60 && me.smsTimer >= 1) {
            me.showTimer = true;
            me.smsTimer--;
          }
        }, 1000);
      },
      getNeedStatus () {
        return new Promise((resolve, reject) => {
          checkNeedImgCode().then(data => {
            if (data.success) {
              resolve(data.result);
            } else {
              reject(data.errorMsg);
            }
          });
        });
      },
      // 键盘监听enter键登录
      handleKeyDown (e) {
        let key = null
        if (window.event === undefined) {
          key = e.keyCode
        } else {
          key = window.event.keyCode
        }
        if (key === 13) {
          if(this.loginMethods) {
             this.subSignInByMobile()
          } else {
            if(this.needImgCode) {
              this.subSignInByAccountImg();
            } else {
              this.subSignInByAccount();
            }
          }

        }
      },
      subSignInByMobile () {
        const me = this;
        let smsTimestamp = $Cookies.get('smsTimestamp');
        this.$refs[ 'mobileForm' ].validate(valid => {
          if (valid) {
            if (smsTimestamp) {
              smsTimestamp = JSON.parse(this.$Base64.decode(smsTimestamp));
              if (smsTimestamp.mobile === this.mobileData.mobile) {
                let _now = new Date().getTime();
                if (_now - smsTimestamp.timestamp > this.smsDuration * 1000) {
                  $Cookies.remove('smsTimestamp');
                  this.$message.error('未获取或者短信验证码已失效，请先获取短信验证码，再登录');
                  return false;
                }
              }
            } else {
              this.$message.error('未获取或者短信验证码已失效，请先获取短信验证码，再登录');
              return false;
            }

            const params = {
              mobile: this.mobileData.mobile,
              phoneRandcode: this.mobileData.smsCode
            };
            loginByMobile(params).then(data => {
              const { success, result } = data;
              if (success) {
                me.$message({
                  type: 'success',
                  message: '登录成功',
                  duration: 1000,
                  onClose: () => {
                    const { uid, username } = result;
                    const $data = {
                      uid: uid,
                      username: username
                    };
                    $store.dispatch('auth/setUserInfo', $data).then(() => {
                      $Cookies.remove('smsTimestamp');
                      window.location.reload();
                    });
                  }
                });
              } else {
                this.$message.error(data.errorMsg);
              }
            });
          }
        });
      },
      subSignInByAccount () {
        const me = this;
        me.getNeedStatus().then(data => {
          if (data.isShow) {
            me.needImgCode = true;
            me.getImgCode();
          } else {
            me.$refs[ 'accountForm' ].validate(valid => {
              if (valid) {
                let params = {
                  username: me.accountData.account,
                  password: md5(me.accountData.password),
                  platform: 10
                };
                loginByAccount(params).then(data => {
                  const { success, result } = data;
                  if (success) {
                    me.$message({
                      type: 'success',
                      message: '登录成功',
                      duration: 1000,
                      onClose: () => {
                        const { uid, username } = result;
                        const $data = {
                          uid: uid,
                          username: username
                        };
                        $store.dispatch('auth/setUserInfo', $data).then(() => {
                          window.location.reload();
                        });
                      }
                    });
                  } else {
                    me.$message.error(data.errorMsg);
                  }
                });
              }
            });
          }
        }).catch(error => {
          this.$message.error(error);
        });
      },
      subSignInByAccountImg () {
        const me = this;
        me.$refs[ 'accountForm' ].validate(valid => {
          if (valid) {
            let params = {
              username: me.accountData.account,
              password: md5(me.accountData.password),
              randCode: me.accountData.imgCode,
              platform: 10
            };
            loginByAccount(params).then(data => {
              const { success, result } = data;
              if (success) {
                me.$message({
                  type: 'success',
                  message: '登录成功',
                  duration: 1000,
                  onClose: () => {
                    const { uid, username } = result;
                    const $data = {
                      uid: uid,
                      username: username
                    };
                    $store.dispatch('auth/setUserInfo', $data).then(() => {
                      window.location.reload();
                    });
                  }
                });
              } else {
                me.$message.error(data.errorMsg);
              }
            });
          }
        });
      }
    },
    destroyed() {
      window.removeEventListener("keydown", this.handleKeyDown, true);
    },
  };
</script>
<style lang="scss">
    .SignInWrapper {
        .imgCode {
            .el-input {
                .el-input-group__append {
                    padding: 0 15px;
                    background: #fff;

                    img {
                        cursor: pointer;
                        outline: none;
                        user-select: none;
                    }
                }
            }
        }
    }
</style>
